import { AuthInfo, CustomerAcocuntList, ValidAccount } from './../../model/shared/user/user';
import { ReqDeleteAccount } from './../../model/shared/accountdelete';
import { EmailData } from 'app/model/shared/maildata';
import { DepositHistoryResult, DepositHistoryListSearch, BankDepositHistoryResult, DepositHistory } from './../../response/deposithistoryresult';
import { TransactionDetail } from './../../model/shared/transaction/transaction';
import {Payment} from '../../model/shared/transaction/payment';
import {Transaction} from '../../model/shared/transaction/transaction';
import {TransactionSearch} from '../../model/shared/transaction/transactionsearch';
import {User, Agent, Account} from '../../model/shared/user/user';
import {UserSearch} from '../../model/shared/user/usersearch';
import {AccountValidation} from '../../model/shared/user/validation';
import {BranchDetailResult} from '../../response/branchdetailresult';
import {HomeResult} from '../../response/homeresult';
import {BaseResponse} from '../../response/internal/baseresponse';
import {PayoutBranchListResult, PayoutBankListResult} from '../../response/internal/list/agentlistresult';
import {PayoutCountryListResult} from '../../response/internal/list/payoutcountrylist';
import {LoginResult} from '../../response/loginresult';
import {PartnerDetailResult} from '../../response/partnerdetailresult';
import {TransactionApproveResult} from '../../response/transactionapproveresult';
import {TransactionCancelResult} from '../../response/transactioncancelresult';
import {TransactionDetailResult} from '../../response/transactiondetailresult';
import {TransactionListResult} from '../../response/transactionlistresult';
import {TransactionRateResult} from '../../response/transactionrateresult';
import {TransactionSaveResult} from '../../response/transactionsaveresult';
import {UserDetailResult} from '../../response/userdetailresult';
import {UserListResult, ReceiverListResult, CustomerListResult} from '../../response/userlistresult';
import {CustomerUpdateValidResult, UserModifyResult, UserValidateMobile, UserValidateMobileResult, UserVerifyMobile} from '../../response/usermodifyresult';
import {UserRegisterResult} from '../../response/userregistresult';
import {UserRemittanceResult} from '../../response/userremittanceresult';
import {UserStatisticsResult} from '../../response/userstatisticsresult';
import {Login} from '../../view-model/agent/login';
import {TransactionApprove} from '../../view-model/agent/transactionapprove';
import {TransactionCancel} from '../../view-model/agent/transactioncancel';
import {PasswordChange} from '../../view-model/common/passwordchange';
import {UserTransactionList} from '../../model/shared/transaction/transaction';
import {UserTransactionListResult} from '../../response/usertransactionlistresult';


import {Api} from '../config/api';
import {RequestService} from './request.service';
import {SessionService} from './session.service';
import {UserService} from './user.service';
import {Injectable, OnDestroy} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import { ExpiredSearch } from '../../view-model/admin/expiredmanage';
import { PartnerGroupResult } from 'app/response/partnergroupresult';
import { PassNoResult } from 'app/response/passnoresult';
import { AlienRegCardResult } from 'app/response/alienregcardresult';


@Injectable()
export class AgentService implements OnDestroy {

  _options: RequestOptions;
  _isLogin: Boolean = this.sessionService.getAgentLogin();
  _loginSubscription: Subject<boolean>;
  _agentInfo: User;
  constructor(
    public request: RequestService,
    protected _user: UserService,
    public sessionService: SessionService) {
    this._options = new RequestOptions();
    this._options.headers = _user._options.headers;
    this._loginSubscription = sessionService.loginChange;
    this._loginSubscription.subscribe((value) => {
      this._isLogin = value;
    });
  }

  login(loginInfo: Login): Observable<LoginResult> {
    return this.request.post(Api.Agent.Login, this._options, loginInfo._data, LoginResult);
  }

  mypage(login: User): Observable<LoginResult> {
    return this.request.post(Api.Agent.MyPage, this._options, login, LoginResult);
  }

  mypageupdate(agent: Agent): Observable<BaseResponse> {
    return this.request.post(Api.Agent.MyPageUpdate, this._options, agent, BaseResponse);
  }
  passwordupdate(password: PasswordChange): Observable<BaseResponse> {
    return this.request.post(Api.Agent.PasswordUpdate, this._options, password, BaseResponse);
  }

  home(): Observable<HomeResult> {
    return this.request.get(Api.Agent.Home, this._options, HomeResult);
  }

  user(option: UserSearch): Observable<UserListResult> {
    return this.request.post(Api.Agent.User, this._options, option, UserListResult);
  }

  userNationalityList(): Observable<PayoutCountryListResult> {
    return this.request.get(Api.Agent.UserNationalityList, this._options, PayoutCountryListResult);
  }

  userOccupationList(): Observable<BaseResponse> {
    return this.request.get(Api.Agent.UserOccupationList, this._options, BaseResponse);
  }

  userdetail(id: string): Observable<UserDetailResult> {
    return this.request.get(Api.Agent.User + '/' + id + '/detail', this._options, UserDetailResult);
  }

  userregister(user: User): Observable<UserRegisterResult> {
    return this.request.post(Api.Agent.UserRegister, this._options, user, UserRegisterResult);
  }

  usercheck(user: User): Observable<UserRegisterResult> {
    return this.request.post(Api.Agent.UserCheck, this._options, user, UserRegisterResult);
  }

  usermodify(user: User): Observable<UserModifyResult> {
    return this.request.post(Api.Agent.UserModify, this._options, user, UserModifyResult);
  }

  uservalidatemobile(modify: UserValidateMobile): Observable<UserValidateMobileResult> {
    return this.request.post(Api.Agent.UserValidateMobile, this._options, modify, UserValidateMobileResult);
  }

  uservalidatemobileresult(): Observable<UserValidateMobileResult> {
    return this.request.post(Api.Agent.UserValidateMobileResult, this._options, {}, UserValidateMobileResult);
  }

  userverifymobile(modify: UserVerifyMobile): Observable<UserValidateMobileResult> {
    return this.request.post(Api.Agent.UserVerifyMobile, this._options, modify, UserValidateMobileResult);
  }

  userstatistics(id: string, year: number, type: string): Observable<UserStatisticsResult> {
    return this.request.get(Api.Agent.UserStatistics(id, year, type), this._options, UserStatisticsResult);
  }

  userremittance(id: string): Observable<UserRemittanceResult> {
    return this.request.get(Api.Agent.UserRemittance(id), this._options, UserRemittanceResult);
  }

  useraccountregistration(): Observable<BaseResponse> {
    return this.request.get(Api.Agent.UserAccountRegistration, this._options, BaseResponse);
  }

  useraccountvalidation(account: AccountValidation): Observable<BaseResponse> {
    return this.request.post(Api.Agent.UserAccountValidation, this._options, account, BaseResponse);
  }

  transaction(option: TransactionSearch): Observable<TransactionListResult> {
    return this.request.post(Api.Agent.Transaction, this._options, option, TransactionListResult);
  }

  transactiondetail(id: string): Observable<TransactionDetailResult> {
    return this.request.get(Api.Agent.TransactionDetail + '/' + id, this._options, TransactionDetailResult);
  };

  transactioncancel(cancel: TransactionCancel): Observable<TransactionCancelResult> {
    return this.request.post(Api.Agent.TransactionCancel, this._options, cancel, TransactionCancelResult);
  }

  transactionapprove(approve: TransactionApprove): Observable<TransactionApproveResult> {
    return this.request.post(Api.Agent.TransactionApprove, this._options, approve, TransactionApproveResult);
  }

  transactionsender(option: UserSearch): Observable<CustomerListResult> {
    return this.request.post(Api.Agent.TransactionSender, this._options, option, CustomerListResult);
  }

  transactionreceiver(id: string): Observable<ReceiverListResult> {
    return this.request.get(Api.Agent.TransactionReceiver(id), this._options, ReceiverListResult);
  }

  transactioncountry(): Observable<PayoutCountryListResult> {
    return this.request.get(Api.Agent.TrnasactionCountry, this._options, PayoutCountryListResult);
  }

  transactionbankbranch(partner: string, payout_type: string): Observable<PayoutBranchListResult> {
    return this.request.get(Api.Agent.TrnasactionPayoutBranch(partner, payout_type), this._options, PayoutBranchListResult);
  }

  transactionbank(partner: string): Observable<PayoutBankListResult> {
    return this.request.get(Api.Agent.TrnasactionPayoutBank(partner), this._options, PayoutBankListResult);
  }

  transactionbankbytype(partner: string, payout_type: string): Observable<PayoutBankListResult> {
    return this.request.get(Api.Agent.TrnasactionPayoutBankByType(partner, payout_type), this._options, PayoutBankListResult);
  }

  transactioncashbranch(partner: string): Observable<PayoutBranchListResult> {
    return this.request.get(Api.Agent.TrnasactionPayoutCashBranch(partner), this._options, PayoutBranchListResult);
  }

  transactionbranchbytype(partner: string, type: string): Observable<PayoutBranchListResult> {
    return this.request.get(Api.Agent.TransactionPayoutBranchByType(partner, type), this._options, PayoutBranchListResult);
  }

  transactionrate(payment: Payment): Observable<TransactionRateResult> {
    return this.request.post(Api.Agent.TransactionRate, this._options, payment, TransactionRateResult);
  }

  transactionsave(transaction: Transaction): Observable<TransactionSaveResult> {
    return this.request.post(Api.Agent.TransactionSave, this._options, transaction, TransactionSaveResult);
  }

  transactionvalid(transaction: Transaction): Observable<BaseResponse> {
    return this.request.post(Api.Agent.TransactionValid, this._options, transaction, BaseResponse);
  }

  transactionotp(transaction: Transaction): Observable<BaseResponse> {
    return this.request.post(Api.Agent.TransactionOTP, this._options, transaction, BaseResponse);
  }

  partnerdetail(partner_id: string): Observable<PartnerDetailResult> {
    return this.request.get(Api.Agent.PartnerDetail(partner_id), this._options, PartnerDetailResult);
  }

  branchdetail(branch_code: string): Observable<BranchDetailResult> {
    return this.request.get(Api.Agent.BranchDetail(branch_code), this._options, BranchDetailResult);
  }

  amlcheck(user: User): Observable<BaseResponse> {
    return this.request.post(Api.Agent.AMLCheck, this._options, user, BaseResponse);
  }

  getUserTransactionList(id: string, year: string, type: string): Observable<UserTransactionListResult> {
    return this.request.get(Api.Agent.UserTransactionList + '/' + id + '/' + year + '/' + type, this._options, UserTransactionList);
  }

  ngOnDestroy() {
    this._loginSubscription.unsubscribe();
  }

  updateKycStatus(id: string, status: string): Observable<BaseResponse> {
    return this.request.get(Api.Agent.UpdateKycStatus + '/' + id + '/' + status, this._options, BaseResponse);
  }

  resetFailedCount(id: string): Observable<BaseResponse> {
    return this.request.get(Api.Agent.ResetFailedCount + '/' + id, this._options, BaseResponse);
  }

  server_version(): Observable<BaseResponse> {
    return this.request.get(Api.Admin.Version, this._options, BaseResponse);
  }

  customerfiledata(customer_idx: string, arg: number): Observable<BaseResponse> {
    return this.request.get(Api.Agent.CustomerFileData + '/' + customer_idx + '/' + arg + '/data', this._options, BaseResponse);
  }

  confirmAccount(confirm_account: Account): Observable<BaseResponse> {
    return this.request.post(Api.Agent.ConfirmAccount, this._options, confirm_account, BaseResponse);
  }

  getexpiredcustomerlist(search: ExpiredSearch): Observable<BaseResponse> {
    return this.request.post(Api.Agent.ExpiredCustomerList, this._options, search, BaseResponse);
  }

  getServiceListByPartner(partner_id: string): Observable<BaseResponse> {
    return this.request.get(Api.Agent.GetServiceListByPartner(partner_id), this._options, BaseResponse);
  }

  isExpiredWithdrawalAccount(customerIdx: string): Observable<BaseResponse> {
    return this.request.get(Api.Agent.isExpiredWithdrawalAccount(customerIdx), this._options, BaseResponse);
  }

  sendUserPwChangePassCode(idx: string): Observable<BaseResponse> {
    return this.request.get(Api.Agent.sendUserPwChangePassCode(idx), this._options, BaseResponse);
  }

  transactioncheckdeposit(detail: TransactionDetail): Observable<DepositHistoryResult> {
    return this.request.post(Api.Agent.TransactionCheckDeposit, this._options, detail, DepositHistoryResult);
  }

  transactionrefreshdeposit(detail: TransactionDetail): Observable<DepositHistoryResult> {
    return this.request.post(Api.Agent.TransactionRefreshDeposit, this._options, detail, DepositHistoryResult);
  }

  sendpdfemailtxnvoucher(data: EmailData): Observable<BaseResponse> {
    return this.request.post(Api.Agent.SendPdfEmail('voucher'), this._options, data, BaseResponse);
  }

  sendpdfemailcustomercertificate(data: EmailData): Observable<BaseResponse> {
    return this.request.post(Api.Agent.SendImgs, this._options, data, BaseResponse);
  }

  deletecustomeraccount(data: ReqDeleteAccount): Observable<BaseResponse> {
    return this.request.post(Api.Agent.DeleteAccount, this._options, data, BaseResponse);
  }

  customermodifyvalid(user: User): Observable<CustomerUpdateValidResult> {
    return this.request.post(Api.Agent.CustomerModifyValid, this._options, user, CustomerUpdateValidResult);
  }

  accountvalidation(account: ValidAccount): Observable<BaseResponse> {
    return this.request.post(Api.Agent.AccountValidation, this._options, account, BaseResponse);
  }

  deposithistory(option: DepositHistoryListSearch): Observable<BankDepositHistoryResult> {
    return this.request.post(Api.Agent.DepositHistyoryList, this._options, option, BankDepositHistoryResult);
  }

  depositinfo(history: DepositHistory): Observable<BaseResponse> {
    return this.request.post(Api.Agent.DepositInfo, this._options, history, BaseResponse);
  }

  transactioncomment(detail: TransactionDetail): Observable<BaseResponse> {
    return this.request.post(Api.Agent.OutTransactionComment, this._options, detail, BaseResponse);
  }

  getpayoutbranches(partner: string, bank_code: string, payout_type: string): Observable<PayoutBranchListResult> {
    const reqBody = new Object();
    reqBody['partner_id'] = partner;
    reqBody['bank_code'] = bank_code;
    reqBody['payout_type'] = payout_type;
    return this.request.post(Api.Agent.GetPayoutBranches, this._options, reqBody, PayoutBranchListResult);
  }

  sendauthcodetostaff(customer_idx: string): Observable<BaseResponse> {
    const reqBody = new Object();
    reqBody['customer_idx'] = customer_idx;
    return this.request.post(Api.Agent.SendAuthCodeToStaff, this._options, reqBody, BaseResponse);
  }

  getcustomercountbykyc(): Observable<BaseResponse> {
    return this.request.get(Api.Agent.CustomerCountByKyc, this._options, BaseResponse);
  }

  payoutpartnergrouplist(): Observable<PartnerGroupResult> {
    return this.request.get(Api.Agent.PayoutPartnerGroupList, this._options, PartnerGroupResult);
  }

  requestReauthEmail(data: AuthInfo): Observable<BaseResponse> {
    return this.request.post(Api.Agent.RequestReauthEmail, this._options, data, BaseResponse);
  }

  queryStatusAuthEmail(customer_idx: string): Observable<BaseResponse> {
    return this.request.get(Api.Agent.QueryStatusAuthEmail(customer_idx), this._options, BaseResponse);
  }

  getCustomersAccountList(data: CustomerAcocuntList): Observable<BaseResponse> {
    return this.request.post(Api.Agent.CustomerAccouintList, this._options, data, BaseResponse);
  }

  getCustomerPassport(data: string): Observable<PassNoResult>{
    return this.request.get(Api.Agent.FindCustomerPassNo(data), this._options,BaseResponse);
  }

  getCustomerAlienCard(data: string): Observable<AlienRegCardResult> {
    return this.request.get(
      Api.Agent.FindCustomerAlineCard(data),
      this._options,
      BaseResponse
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/agent.service.ts